<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content relative bg-white rounded-xl">
                <DashboardFlashSaleSlider
                    class="p-4"
                    :apiConfig="dashboardConfig">
                </DashboardFlashSaleSlider>
                <div class="close-position" @click="hide()">
                    <img src="@/assets/icon/ic-close-circle.svg" alt="">
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";
import DashboardFlashSaleSlider from "@/components/Dashboard/DashboardFlashSaleSlider.vue";

export default {
    name: "AlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
        DashboardFlashSaleSlider,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
            dashboardConfig: ConfigManager.getDashboardConfig().flashsale,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        overflow: unset;

        .modal-content {
            overflow: unset;
        }

        .divider {
            height: 1px;
        }
        .close-position {
            position: absolute;

            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
